import React, { FC } from "react"

import { px, useMantineTheme } from "@mantine/core"
import { IconBattery3 } from "@tabler/icons-react"

import ChartCard from "../../../analytics/components/chart-card/ChartCard"
import { useHealth } from "../../../../contexts/health-context"
import dayjs from "dayjs"
import { useLanguage } from "../../../../contexts/language-context"

type DeviceBatteryChartProps = unknown

const DeviceBatteryChart: FC<DeviceBatteryChartProps> = () => {
    const { data } = useHealth()
    const theme = useMantineTheme()
    const { L } = useLanguage()

    return (
        <ChartCard
            label={L("Battery")}
            option={{
                grid: { top: 0, right: 0, bottom: px("1.25rem"), left: 0 },
                xAxis: { type: "time" },
                yAxis: { type: "value", max: 101, min: 0, show: false },
                dataset: {
                    dimensions: [
                        { name: "timestamp", displayName: "", type: "time" },
                        { name: "battery", displayName: L("Percentage"), type: "float" },
                    ],
                    source: data.map(health => ({ ...health, timestamp: health.timestamp.toDate() })),
                },
                series: [
                    {
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        lineStyle: {
                            color: theme.colors.gold[theme.colorScheme === "dark" ? 4 : 6],
                        },
                    },
                ],
                tooltip: { trigger: "axis", valueFormatter: (value: number) => value !== null ? `${value}%` : "unknown" },
                dataZoom: [{ type: "inside", startValue: dayjs().hour(4).toDate(), endValue: dayjs().toDate() }],
            }}
            icon={IconBattery3}
        />
    )
}

export default DeviceBatteryChart
